import {
  SaveWorkOrderActivityMutation,
  SaveWorkOrderActivityMutationVariables,
  CancelRequestForUpdatesMutation,
  CancelRequestForUpdatesMutationVariables,
  CompleteChangeStatusRecordTaskMutation,
  CompleteChangeStatusRecordTaskMutationVariables,
  CompleteMigrateRecordTaskMutation,
  CompleteMigrateRecordTaskMutationVariables,
  CompleteRecordTaskMutation,
  CompleteRecordTaskMutationVariables,
  CompleteScheduleNotificationsRecordTaskMutation,
  CompleteScheduleNotificationsRecordTaskMutationVariables,
  CompleteSelectStepRecordTaskMutation,
  CompleteSelectStepRecordTaskMutationVariables,
  CompleteSetExpirationRecordTaskMutation,
  CompleteSetExpirationRecordTaskMutationVariables,
  DeclineReviewForRecordTaskMutation,
  DeclineReviewForRecordTaskMutationVariables,
  DeleteRecordTaskMutation,
  DeleteRecordTaskMutationVariables,
  DeleteRequestedRecordTaskMutation,
  DeleteRequestedRecordTaskMutationVariables,
  FinalizeApplicationReviewMutation,
  FinalizeApplicationReviewMutationVariables,
  FinalizePlanReviewMutation,
  FinalizePlanReviewMutationVariables,
  GenerateCustomTaskReportMutation,
  GenerateCustomTaskReportMutationVariables,
  GenerateDocumentMutation,
  GenerateDocumentMutationVariables,
  GetRecordTaskReassignmentInfoQuery,
  GetRecordTaskReassignmentInfoQueryVariables,
  IssueDocumentMutation,
  IssueDocumentMutationVariables,
  MarkAddressedMutation,
  MarkAddressedMutationVariables,
  MarkRecordTaskCompleteMutation,
  MarkRecordTaskCompleteMutationVariables,
  ReassignRecordTaskMutation,
  ReassignRecordTaskMutationVariables,
  ReassignLogWorkOrderActivityMutation,
  ReassignLogWorkOrderActivityMutationVariables,
  RequestUpdatesMutation,
  RequestUpdatesMutationVariables,
  RouteForPlanReviewManualMutation,
  RouteForPlanReviewManualMutationVariables,
  RouteRecordTaskForReviewMutation,
  RouteRecordTaskForReviewMutationVariables,
  SatisfyCreateRecordTaskMutation,
  SatisfyCreateRecordTaskMutationVariables,
  SaveCustomRecordTaskFieldsMutation,
  SaveCustomRecordTaskFieldsMutationVariables,
  UpdateApplicationReviewMutation,
  UpdateApplicationReviewMutationVariables,
  UpdateRecordTaskDueDateMutation,
  UpdateRecordTaskDueDateMutationVariables,
} from '../../types/graphql'
import { QueryKey, useMutation, useQuery } from '../utils/queryClient'

const RouteRecordTaskForReview = gql`
  mutation RouteRecordTaskForReviewMutation($id: Int!, $input: RouteForReviewManualInput!) {
    routeRecordTaskForReview(id: $id, input: $input) {
      id
    }
  }
`

export const useRouteRecordTaskForReviewMutation = () => {
  return useMutation<RouteRecordTaskForReviewMutation, RouteRecordTaskForReviewMutationVariables>({
    mutationDocument: RouteRecordTaskForReview,
  })
}

const DeleteRecordTask = gql`
  mutation DeleteRecordTaskMutation($id: Int!) {
    deleteReviewRecordTask(id: $id) {
      id
    }
  }
`
export const useDeleteRecordTaskMutation = () => {
  return useMutation<DeleteRecordTaskMutation, DeleteRecordTaskMutationVariables>({
    mutationDocument: DeleteRecordTask,
  })
}

const FinalizeApplicationReview = gql`
  mutation FinalizeApplicationReviewMutation(
    $recordTaskId: Int!
    $input: FinalizeApplicationReviewInput!
  ) {
    finalizeApplicationReview(recordTaskId: $recordTaskId, input: $input) {
      id
    }
  }
`

export const useFinalizeApplicationReviewMutation = () => {
  return useMutation<FinalizeApplicationReviewMutation, FinalizeApplicationReviewMutationVariables>(
    {
      mutationDocument: FinalizeApplicationReview,
    }
  )
}

const UpdateApplicationReview = gql`
  mutation UpdateApplicationReviewMutation(
    $recordTaskId: Int!
    $input: FinalizeApplicationReviewInput!
  ) {
    updateApplicationReview(recordTaskId: $recordTaskId, input: $input) {
      id
    }
  }
`

export const useUpdateApplicationReviewMutation = () => {
  return useMutation<UpdateApplicationReviewMutation, UpdateApplicationReviewMutationVariables>({
    mutationDocument: UpdateApplicationReview,
  })
}

const MarkRecordTaskComplete = gql`
  mutation MarkRecordTaskCompleteMutation($input: CompleteRecordTaskInput!) {
    markComplete(input: $input) {
      id
    }
  }
`

export const useMarkRecordTaskCompleteMutation = () => {
  return useMutation<MarkRecordTaskCompleteMutation, MarkRecordTaskCompleteMutationVariables>({
    mutationDocument: MarkRecordTaskComplete,
  })
}

const DeclineReviewForRecordTask = gql`
  mutation DeclineReviewForRecordTaskMutation($id: Int!, $input: DeclineReviewInput!) {
    declineReviewForRecordTask(id: $id, input: $input) {
      id
    }
  }
`

export const useDeclineToReviewMutation = () => {
  return useMutation<
    DeclineReviewForRecordTaskMutation,
    DeclineReviewForRecordTaskMutationVariables
  >({
    mutationDocument: DeclineReviewForRecordTask,
  })
}

const UpdateRecordTaskDueDate = gql`
  mutation UpdateRecordTaskDueDateMutation($id: Int!, $dueDate: DateTime) {
    updateRecordTaskDueDate(id: $id, dueDate: $dueDate) {
      id
    }
  }
`
export const useUpdateRecordTaskDueDateMutation = () => {
  return useMutation<UpdateRecordTaskDueDateMutation, UpdateRecordTaskDueDateMutationVariables>({
    mutationDocument: UpdateRecordTaskDueDate,
  })
}

const Reassign = gql`
  mutation ReassignRecordTaskMutation($id: Int!, $newOwnerUserId: Int!) {
    reassignRecordTask(id: $id, newOwnerUserId: $newOwnerUserId) {
      id
    }
  }
`

export const useReassignRecordTaskMutation = () => {
  return useMutation<ReassignRecordTaskMutation, ReassignRecordTaskMutationVariables>({
    mutationDocument: Reassign,
  })
}

const ReassignLogWorkOrderActivity = gql`
  mutation ReassignLogWorkOrderActivityMutation($input: ReassignLogWorkOrderActivityInput!) {
    reassignLogWorkOrderActivity(input: $input) {
      id
      dueDate
      ownerUser {
        ...UserDataFragment
      }
      workOrderType {
        id
        name
      }
    }
  }
`

export const useReassignLogWorkOrderActivityMutation = () => {
  return useMutation<
    ReassignLogWorkOrderActivityMutation,
    ReassignLogWorkOrderActivityMutationVariables
  >({
    mutationDocument: ReassignLogWorkOrderActivity,
  })
}

const FinalizePlanReview = gql`
  mutation FinalizePlanReviewMutation($input: FinalizePlanReviewInput!) {
    finalizePlanReview(input: $input) {
      id
    }
  }
`
export const useFinalizePlanReviewMutation = () => {
  return useMutation<FinalizePlanReviewMutation, FinalizePlanReviewMutationVariables>({
    mutationDocument: FinalizePlanReview,
  })
}

const GenerateDocument = gql`
  mutation GenerateDocumentMutation($input: IssueInput!) {
    generateDocument(input: $input) {
      id
    }
  }
`
export const useGenerateDocumentMutation = () => {
  return useMutation<GenerateDocumentMutation, GenerateDocumentMutationVariables>({
    mutationDocument: GenerateDocument,
  })
}

const IssueDocument = gql`
  mutation IssueDocumentMutation($input: IssueInput!) {
    issueRecordTaskGroup(input: $input)
  }
`
export const useIssueDocumentMutation = () => {
  return useMutation<IssueDocumentMutation, IssueDocumentMutationVariables>({
    mutationDocument: IssueDocument,
  })
}

const Complete = gql`
  mutation CompleteRecordTaskMutation($input: CompleteRecordTaskInput!) {
    completeRecordTask(input: $input) {
      id
    }
  }
`
export const useCompleteRecordTaskMutation = () => {
  return useMutation<CompleteRecordTaskMutation, CompleteRecordTaskMutationVariables>({
    mutationDocument: Complete,
  })
}

const SaveDraft = gql`
  mutation SaveCustomRecordTaskFieldsMutation($input: SaveCustomRecordTaskFieldsInput!) {
    saveCustomRecordTaskFields(input: $input) {
      id
    }
  }
`
export const useSaveCustomRecordTaskFieldsMutation = () => {
  return useMutation<
    SaveCustomRecordTaskFieldsMutation,
    SaveCustomRecordTaskFieldsMutationVariables
  >({
    mutationDocument: SaveDraft,
  })
}

const CancelRequestForUpdates = gql`
  mutation CancelRequestForUpdatesMutation($recordTaskId: Int!) {
    cancelRequestForUpdates(recordTaskId: $recordTaskId) {
      id
    }
  }
`
export const useCancelRequestForUpdatesMutation = () => {
  return useMutation<CancelRequestForUpdatesMutation, CancelRequestForUpdatesMutationVariables>({
    mutationDocument: CancelRequestForUpdates,
  })
}

const MarkAddressed = gql`
  mutation MarkAddressedMutation($input: CompleteRecordTaskInput!) {
    markAddressed(input: $input) {
      id
    }
  }
`
export const useMarkAddressedMutation = () => {
  return useMutation<MarkAddressedMutation, MarkAddressedMutationVariables>({
    mutationDocument: MarkAddressed,
  })
}

const RequestUpdates = gql`
  mutation RequestUpdatesMutation($input: RequestUpdatesInput!) {
    requestUpdates(input: $input) {
      id
    }
  }
`
export const useRequestUpdatesMutation = () => {
  return useMutation<RequestUpdatesMutation, RequestUpdatesMutationVariables>({
    mutationDocument: RequestUpdates,
  })
}

const RouteForPlanReview = gql`
  mutation RouteForPlanReviewManualMutation($input: RouteForPlanReviewManualInput!) {
    routeForPlanReviewManual(input: $input) {
      id
    }
  }
`
export const useRouteForPlanReviewManualMutation = () => {
  return useMutation<RouteForPlanReviewManualMutation, RouteForPlanReviewManualMutationVariables>({
    mutationDocument: RouteForPlanReview,
  })
}

const CompleteScheduleNotificationsRecordTask = gql`
  mutation CompleteScheduleNotificationsRecordTaskMutation(
    $id: Int!
    $inputs: [CreateRecordScheduledEventInput!]
  ) {
    completeScheduleNotificationsRecordTask(id: $id, inputs: $inputs) {
      id
    }
  }
`
export const useCompleteScheduleNotificationsRecordTaskMutation = () => {
  return useMutation<
    CompleteScheduleNotificationsRecordTaskMutation,
    CompleteScheduleNotificationsRecordTaskMutationVariables
  >({
    mutationDocument: CompleteScheduleNotificationsRecordTask,
  })
}

const CompleteSetExpirationRecordTask = gql`
  mutation CompleteSetExpirationRecordTaskMutation(
    $id: Int!
    $input: CompleteSetExpirationRecordTaskInput!
  ) {
    completeSetExpirationRecordTask(id: $id, input: $input) {
      id
    }
  }
`
export const useCompleteSetExpirationRecordTaskMutation = () => {
  return useMutation<
    CompleteSetExpirationRecordTaskMutation,
    CompleteSetExpirationRecordTaskMutationVariables
  >({
    mutationDocument: CompleteSetExpirationRecordTask,
  })
}

const Migrate = gql`
  mutation CompleteMigrateRecordTaskMutation($id: Int!) {
    completeMigrateRecordTask(id: $id) {
      id
    }
  }
`
export const useCompleteMigrateRecordTaskMutation = () => {
  return useMutation<CompleteMigrateRecordTaskMutation, CompleteMigrateRecordTaskMutationVariables>(
    {
      mutationDocument: Migrate,
    }
  )
}

const CompleteSelectStepRecordTask = gql`
  mutation CompleteSelectStepRecordTaskMutation($id: Int!, $newRecordTaskGroupId: Int!) {
    completeSelectStepRecordTask(id: $id, newRecordTaskGroupId: $newRecordTaskGroupId) {
      id
    }
  }
`
export const useCompleteSelectStepRecordTaskMutation = () => {
  return useMutation<
    CompleteSelectStepRecordTaskMutation,
    CompleteSelectStepRecordTaskMutationVariables
  >({
    mutationDocument: CompleteSelectStepRecordTask,
  })
}

const DeleteRequestedRecordTask = gql`
  mutation DeleteRequestedRecordTaskMutation($id: Int!) {
    deleteRequestedRecordTask(id: $id) {
      id
    }
  }
`
export const useDeleteRequestedRecordTaskMutation = () => {
  return useMutation<DeleteRequestedRecordTaskMutation, DeleteRequestedRecordTaskMutationVariables>(
    {
      mutationDocument: DeleteRequestedRecordTask,
    }
  )
}

const SatisfyCreateRecordTaskWithExistingRecord = gql`
  mutation SatisfyCreateRecordTaskMutation(
    $input: SatisfyCreateRecordTaskWithExistingRecordInput!
  ) {
    satisfyCreateRecordTaskWithExistingRecord(input: $input) {
      id
    }
  }
`
export const useSatisfyCreateRecordTaskWithExistingRecordMutation = () => {
  return useMutation<SatisfyCreateRecordTaskMutation, SatisfyCreateRecordTaskMutationVariables>({
    mutationDocument: SatisfyCreateRecordTaskWithExistingRecord,
  })
}

const GetRecordTaskReassignmentInfo = gql`
  query GetRecordTaskReassignmentInfoQuery($recordTaskId: Int!) {
    recordTaskOwnerOptions(recordTaskId: $recordTaskId) {
      ...RecordTaskOwnerOptionFragment
    }
  }
  fragment RecordTaskOwnerOptionFragment on RecordTaskOwnerOption {
    isDisabled
    label
    user {
      ...UserDataFragment
    }
  }
`
export const useRecordTaskReassignmentInfoQuery = (recordTaskId: number) => {
  return useQuery<GetRecordTaskReassignmentInfoQuery, GetRecordTaskReassignmentInfoQueryVariables>({
    queryKey: [QueryKey.RecordTaskReassignmentInfo, recordTaskId],
    queryDocument: GetRecordTaskReassignmentInfo,
    variables: {
      recordTaskId,
    },
    gcTime: 0,
    staleTime: 0,
  })
}

const CompleteChangeStatusRecordTask = gql`
  mutation CompleteChangeStatusRecordTaskMutation(
    $id: Int!
    $input: CompleteChangeStatusRecordTaskInput!
  ) {
    completeChangeStatusRecordTask(id: $id, input: $input) {
      id
    }
  }
`

export const useCompleteChangeStatusRecordTaskMutation = () => {
  return useMutation<
    CompleteChangeStatusRecordTaskMutation,
    CompleteChangeStatusRecordTaskMutationVariables
  >({ mutationDocument: CompleteChangeStatusRecordTask })
}

const GenerateCustomTaskReport = gql`
  mutation GenerateCustomTaskReportMutation($recordTaskId: Int!) {
    generateCustomTaskReport(recordTaskId: $recordTaskId) {
      ...FileFragment
    }
  }
`

export const useGenerateCustomTaskReportMutation = () => {
  return useMutation<GenerateCustomTaskReportMutation, GenerateCustomTaskReportMutationVariables>({
    mutationDocument: GenerateCustomTaskReport,
  })
}

const SaveWorkOrderActivity = gql`
  mutation SaveWorkOrderActivityMutation($input: SaveWorkOrderActivityInput!) {
    saveWorkOrderActivity(input: $input) {
      id
      workOrderActivityCompletionDate
      workOrderActivityStartDate
      workOrderActivityComments
      workOrderType {
        id
        name
      }
      workOrderActivityCustomFieldsFieldGroup {
        ...FieldGroupFragment
      }
      workOrderActivityBeforePhotosField {
        ...FieldFragment
      }
      workOrderActivityAfterPhotosField {
        ...FieldFragment
      }
    }
  }
`

export const useSaveWorkOrderActivityMutation = () => {
  return useMutation<SaveWorkOrderActivityMutation, SaveWorkOrderActivityMutationVariables>({
    mutationDocument: SaveWorkOrderActivity,
  })
}
